import {
  registrationCompletedFromSnow,
  deleteRegistrationCookie,
} from '../utils/trackingHelper';

export default function trackRegistrationCompleted() {
  // Cookie の中身が Snow 関連だった場合のみ発火
  if (!registrationCompletedFromSnow()) {
    return;
  }

  // Remove Cookie
  deleteRegistrationCookie();
}
